import cn from 'classnames'
import type {IconType} from 'src/common/Icon'
import {Icon} from 'src/common/Icon'

type IconBadgeSize = 's' | 'm' | 'l'

const SIZE_CLASS: Record<IconBadgeSize, string> = {
  s: 'size-[30px] text-[15px]',
  m: 'size-11 text-[22px]',
  l: 'size-14 text-[28px]',
}

export type IconBadgeProps = {
  icon: IconType
  size?: IconBadgeSize
}

export const IconBadge = ({icon, size = 's'}: IconBadgeProps) => (
  <span
    className={cn(
      'flex shrink-0 items-center justify-center rounded-control border border-green-neon/35 bg-badge-icon text-green-neon',
      SIZE_CLASS[size],
    )}
  >
    <Icon name={icon} className="size-[1em]" />
  </span>
)
